import {
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { brand } from "../../shared-theme/themePrimitives";

const ServiceStatus = () => {
  const theme = useTheme();

  const services = [
    { name: "Email Service", status: "operational", uptime: 99.98 },
    { name: "Authentication", status: "operational", uptime: 99.99 },
    { name: "File Storage", status: "degraded", uptime: 97.32 },
    { name: "Database", status: "operational", uptime: 99.95 },
    { name: "API Gateway", status: "outage", uptime: 89.76 },
    { name: "CRM System", status: "operational", uptime: 99.87 },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "operational":
        return theme.palette.success.main;
      case "degraded":
        return theme.palette.warning.main;
      case "outage":
        return theme.palette.error.main;
      default:
        return theme.palette.info.main;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "operational":
        return "Operational";
      case "degraded":
        return "Degraded";
      case "outage":
        return "Outage";
      default:
        return "Unknown";
    }
  };

  return (
    <Card
      sx={{
        height: "100%",
        transition: "all 0.3s ease",
        backgroundColor: theme.palette.mode === "light" ? "#fff" : brand[800],
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
          Service Status
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {services.map((service) => (
              <Grid item xs={12} key={service.name}>
                <Box sx={{ mb: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 0.5,
                    }}
                  >
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {service.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: getStatusColor(service.status),
                        fontWeight: 600,
                      }}
                    >
                      {getStatusText(service.status)}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box sx={{ width: "100%", mr: 1 }}>
                      <LinearProgress
                        variant="determinate"
                        value={service.uptime}
                        sx={{
                          height: 8,
                          borderRadius: 4,
                          backgroundColor:
                            theme.palette.mode === "light"
                              ? theme.palette.grey[200]
                              : theme.palette.grey[700],
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: getStatusColor(service.status),
                            borderRadius: 4,
                          },
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {service.uptime}%
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceStatus;
